import React from 'react';
import { Route } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ProtectedRoute = ({ component, ...args }: React.PropsWithChildren<any>) => (
  <Route component={withAuthenticationRequired(component, {})} {...args} />
);
